import { render, staticRenderFns } from "./BillingDetailsModal.vue?vue&type=template&id=70570fef&"
import script from "./BillingDetailsModal.vue?vue&type=script&lang=js&"
export * from "./BillingDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports